import { TypeActionCreateOTP } from 'src/utils/constants/enum';
import { create } from 'zustand';

export interface IVerifyOTP {
  type?: TypeVerify;
  actionCreateOTP?: TypeActionCreateOTP
}

interface IAction {
  dispatch: (s: TypeVerify | TypeActionCreateOTP, key: keyof IVerifyOTP) => void,
}

export const useVerifyTypeStore = create<IVerifyOTP & IAction>((set) => ({
  type: undefined,
  actionCreateOTP: undefined,
  dispatch: (s: TypeVerify | TypeActionCreateOTP, key: keyof IVerifyOTP) => set({ [key]: s })
}));
